import { matchPath } from "react-router"
import { RouterAction, LOCATION_CHANGE } from "connected-react-router"
import { Reducer } from "redux"

import { abstractRoutePaths } from "../../../Routes"
import { AuthUserType, StatisticsType } from "../../../Actions/Types"
import { AuthAction } from "../../Auth"

export interface StatisticsState {
    url?: string | null
}

interface GetStatisticsSnapshotAction {
    type: StatisticsType.getStatisticsSnapshot
    payload: StatisticsState
}

export type StatisticsAction = GetStatisticsSnapshotAction

const initialState: StatisticsState = {}

export const StatisticsReducer: Reducer<
    StatisticsState,
    StatisticsAction | AuthAction | RouterAction
> = (state = initialState, action): StatisticsState => {
    switch (action.type) {
        case LOCATION_CHANGE:
            const isAppStatistics =
                matchPath(action.payload.location.pathname, {
                    path: abstractRoutePaths.appDetailOverview
                }) !== null

            return isAppStatistics
                ? state
                : {
                      ...state,
                      url: undefined
                  }
        case StatisticsType.getStatisticsSnapshot:
            return {
                ...state,
                url: action.payload.url
            }
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
